import React, { useEffect } from "react";

// Antd
import { Layout, Menu } from "antd";

import { useLocation, useHistory } from "react-router-dom";

import {
  SUPER_ADMIN_MENU_ITEMS,
  ADMIN_MENU_ITEMS,
  STUDENT_MENU_ITEMS,
  INSTRUCTOR_MENU_ITEMS,
  COORDINATOR_MENU_ITEMS,
} from "../../../../Constants/Menu/menus";

import { SUPER_ADMIN, ADMIN, STUDENT, INSTRUCTOR, COORDINATOR } from "../../../../Constants/Roles/roles";


import "./style.scss";

const { Sider } = Layout;

const SideBar = ({ userData, collapsed, setCollapsed }) => {
  const location = useLocation();
  const history = useHistory();
  const pathname = location.pathname;

  useEffect(() => {
    if (pathname === "/dashboard" || pathname === "/dashboard/") {
      history.push("/dashboard/home");
    }
  }, [pathname, history]);

  const handleNavClick = () => {
    if (window.innerWidth < 768) {
      setCollapsed(true);
    }
  };

  return (
    <Sider
      breakpoint="md"
      collapsedWidth="80"
      onCollapse={(collapsed) => setCollapsed(collapsed)}
      collapsed={collapsed}
      collapsible
    >
      <div className="header-logo-vertical">
        <img
          src={require("../../../../Assets/Logos/ibas_logo.jpeg")}
          alt="logo"
          className="logo-white"
        />
        <img
          src={require("../../../../Assets/Logos/ibas_logo.jpeg")}
          alt="logo"
          className="logo-D"
        />
      </div>
      <Menu
        className="sidebar-menu"
        theme="dark"
        mode="inline"
        items={
          userData.role === SUPER_ADMIN
            ? SUPER_ADMIN_MENU_ITEMS.map((item) => ({
                key: item.key,
                icon: item.icon,
                label: item.label,
                onClick: () => {
                  handleNavClick();
                  history.push(item.href);
                },
              }))
            : userData.role === ADMIN
              ? ADMIN_MENU_ITEMS.map((item) => ({
                  key: item.key,
                  icon: item.icon,
                  label: item.label,
                  onClick: () => {
                    handleNavClick();
                    history.push(item.href);
                  },
                }))
              : userData.role === INSTRUCTOR
                ? INSTRUCTOR_MENU_ITEMS.map((item) => ({
                    key: item.key,
                    icon: item.icon,
                    label: item.label,
                    onClick: () => {
                      handleNavClick();
                      history.push(item.href);
                    },
                  }))
                : userData.role === COORDINATOR
                  ? COORDINATOR_MENU_ITEMS.map((item) => ({
                      key: item.key,
                      icon: item.icon,
                      label: item.label,
                      onClick: () => {
                        handleNavClick();
                        history.push(item.href);
                      },
                    }))
                  : userData.role === STUDENT
                    ? STUDENT_MENU_ITEMS.map((item) => ({
                        key: item.key,
                        icon: item.icon,
                        label: item.label,
                        onClick: () => {
                          handleNavClick();
                          history.push(item.href);
                        },
                      }))
                    : []
        }
        defaultSelectedKeys={
          pathname.includes("home")
            ? ["1"]
            : pathname.includes("users") || pathname.includes("users")
              ? ["2"]
              : pathname.includes("mycources")
                ? ["8"]
                : pathname.includes("cources")
                  ? ["3"]
                  : pathname.includes("assessments")
                    ? ["4"]
                    : pathname.includes("attendance")
                      ? ["6"]
                      : pathname.includes("payments")
                        ? ["7"]
                      : pathname.includes("revenue")
                        ? ["12"]
                        : pathname.includes("notes")
                          ? ["8"]
                          : pathname.includes("certificates")
                            ? ["5"]
                            : pathname.includes("wishlist")
                              ? ["9"]
                              : pathname.includes("badges")
                                ? ["11"]
                                : pathname.includes("centers")
                                  ? ["10"]
                                  : []
        }
      />
    </Sider>
  );
};

export default SideBar;
